import { isBrowser as r } from "./ghl-ui.es1144.js";
let i = !1;
function t() {
  if (r && window.CSS && !i && (i = !0, "registerProperty" in (window == null ? void 0 : window.CSS)))
    try {
      CSS.registerProperty({
        name: "--n-color-start",
        syntax: "<color>",
        inherits: !1,
        initialValue: "#0000"
      }), CSS.registerProperty({
        name: "--n-color-end",
        syntax: "<color>",
        inherits: !1,
        initialValue: "#0000"
      });
    } catch {
    }
}
export {
  t as useHoudini
};
